const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/schedulingSlot.ts';
import moment, { Moment } from 'moment';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';

export const ACTION_TYPE_RESET_APPOINTMENT_BOOKING_SLOTS = 'PATAPP_RESET_APPOINTMENT_BOOKING_SLOTS';
export const REQUEST_ACTION_TYPES_LOAD_SCHEDULING_SLOTS = kisapiActionTypes('PATAPP_LOAD_SCHEDULING_SLOT');
export const REQUEST_ACTION_TYPES_LOAD_SCHEDULING_SLOTS_FOR_TERMIN = kisapiActionTypes('AVAILABLE_SLOTS_FOR_TERMIN');

export function loadAvailableSchedulingSlotsForPlan(
    planICode: string,
    maxDays: number,
    splitSlots: number,
    date?: Moment
) {
    const params = {
        PlanIcode: planICode,
        MaxDays: maxDays.toString(),
        SplitSlots: splitSlots.toString(),
        ...(date && { SearchDat: moment(date).format('YYYY-MM-DD HH:mm') }),
    };

    const queryString = new URLSearchParams(params).toString();
    const endpoint = `appointments/slots?${queryString}`;
    return createPatapiCall(REQUEST_ACTION_TYPES_LOAD_SCHEDULING_SLOTS, endpoint, HttpMethod.GET);
}

export function resetAppointmentBookingSlots() {
    return {
        type: ACTION_TYPE_RESET_APPOINTMENT_BOOKING_SLOTS,
    };
}

export function loadSchedulingSlotsForTermin(terminNr: string, fromDate: Moment, dayCount: number = 10) {
    const params = {
        SearchDat: fromDate.format('YYYY-MM-DD HH:mm'),
        MaxDays: dayCount.toString(10),
        SplitSlots: '1',
    };

    const queryString = new URLSearchParams(params).toString();
    const endpoint = `appointments/id/${terminNr}/slots?${queryString}`;

    const meta = {
        terminNr,
        fromDate,
        dayCount,
    };

    return createPatapiCall(
        REQUEST_ACTION_TYPES_LOAD_SCHEDULING_SLOTS_FOR_TERMIN,
        endpoint,
        HttpMethod.GET,
        meta,
        undefined
    );
}
